import LegalPage from './LegalPage';

const TermsOfServicePage = () => (
  <LegalPage
    slug="terms-of-service"
    canonical="/terms"
    fallbackTitle="Terms of Service"
    fallbackDescription="The terms that govern your use of UniXperts services."
  />
);

export default TermsOfServicePage;
